/** 门户资源广场路由前缀（与数据中心 / 租户控制台路径区分） */
export const PUBLIC_PLAZA_PREFIX = '/public';

/** 是否门户资源广场路由（含列表与 `/public/dc/...` 详情） */
export function isPublicPlazaPath(pathname?: string): boolean {
  const path = pathname || '';
  return path === PUBLIC_PLAZA_PREFIX || path.startsWith(`${PUBLIC_PLAZA_PREFIX}/`);
}

export const publicPlazaPaths = {
  modelRepo: `${PUBLIC_PLAZA_PREFIX}/model-repo`,
  /** React Router path pattern */
  modelRepoDetailRoute: `${PUBLIC_PLAZA_PREFIX}/dc/:dc/model-repo/:id`,
  modelRepoDetail: (dc: string, id: string) => `${PUBLIC_PLAZA_PREFIX}/dc/${dc}/model-repo/${id}`,
  appCenter: `${PUBLIC_PLAZA_PREFIX}/app-center`,
  appCenterDetailRoute: `${PUBLIC_PLAZA_PREFIX}/dc/:dc/app-center/:artifactId/versions/:versionId`,
  appCenterDetail: (dc: string, artifactId: string, versionId: string) =>
    `${PUBLIC_PLAZA_PREFIX}/dc/${dc}/app-center/${artifactId}/versions/${versionId}`,
  skillCenter: `${PUBLIC_PLAZA_PREFIX}/skill-center`,
  skillCenterDetailRoute: `${PUBLIC_PLAZA_PREFIX}/dc/:dc/skill-center/:id`,
  skillCenterDetail: (dc: string, id: string) => `${PUBLIC_PLAZA_PREFIX}/dc/${dc}/skill-center/${id}`,
} as const;
